import { RodeoEventRegistration } from "./rodeoEventRegistration";
import { Winner } from './winner';
import { RodeoEventOrder } from "./rodeoEventOrder";
import { RoundStyle } from "./roundStyle";
import { Exhibition } from "./exhibition";
import { EventTypeConfiguration } from "./eventTypeConfiguration";
import { Sidepot } from "./sidepot";
import { RodeoEventCarryOver } from "./rodeoEventCarryOver";
import { RodeoEventPayoutConfig } from "./rodeoEventPayoutConfig";
import { PointSeries } from "./point-series";
import { RodeoEventSchedule } from "./rodeoEventSchedule";
import { PriceTier } from "./price-tier.model";

export class RodeoEvent {
    id: number;
    rodeoId: number;
    eventType: string;
    displayName: string;
    roundStyle: RoundStyle = { id: 1, name: 'Progressive' };
    roundStyleId: number;
    performanceCount: number;
    rounds: number = 1;
    finalRound: boolean = true;
    reverseSecondRound: boolean;
    reverseSecondRoundDragOnly: boolean;
    progressiveAfter: number;
    averageJudgeTotalScores: boolean;
    dropHighLowJudgeScores: boolean;
    
    slide: boolean;
    handicap: boolean;

    drawn: boolean;

    hideEntry: boolean;

    uniqueRunsOnly: boolean;

    stockFee: number;
    lateFee: number;
    lateFeeType: string;
    
    maxEntries: number;
    maxEntriesPerContestant: number = 1;
    allowBuddies: boolean = true;
    castLeaders: boolean = false;
    upAndBack: boolean = true;

    horseRequired: boolean = false;
    horseAgeFloor: number = 1;
    horseAgeCap: number = 40;
    horseUpAndBack: boolean = true;
    
    idealTeamRank: number;
    halfRankDownOffset: number;
    halfRankUpOffset: number;
    handicapLimit: number;
    handicapFloor: number;
    handicapCap: number;

    allowDrawAll: boolean;
    allowTBA: boolean;
    pickAmount: number;
    drawAmount: number;

    nominationId: number;

    maxDivisions: number = 1;
    leaderDivisions: boolean = false;
    divisionOffsets: any;
    ageCheckDate: string;

    dragEvery: number = 10;
    bigDragEvery: number = 50;

    addedMoney: number = 0;
    guaranteedMoney: number = 0;
    done: boolean = false;
    entryCost: number = 100;
    ageFloor: number = 0;
    ageCap: number = 100;
    ageMethod: string = "Day Of";
    teammateEntry: boolean = false;
    preferencesAllowed: number = 2;
    ropingFormat: string;

    registrationStartDate: string;
    registrationEndDate: string;

    qualifiedByPointSeries: PointSeries;
    qualifiedByPointSeriesId: number;
    qualifierCutOffPlace: number;

    barrelPenalty: number;
    barrierPenalty: number;
    crossfireTimePenalty: number;

    cutOffTime: number;
    cutOffTimes: string[];

    showBaseTime: number = 25;
    baseJudgeScore: number = 0;
    rotationMax: number = 0;

    shortGo: boolean;
    shortGoMax: number;
    shortGoDestinationScheduleId: number;
    fallBackToFill: boolean = false;
    fallBackToPlace: boolean = true;

    drawFirstToEnterLastToCompete: boolean = false;

    nextRoundRunOffset: number;
    nextRoundStockOffset: number;

    updated: string;

    carryOvers: RodeoEventCarryOver[] = [];
    eventOrders: RodeoEventOrder[] = [];
    schedules: RodeoEventSchedule[] = [];
    registrations: RodeoEventRegistration[] = [];
    winners: Winner[] = [];
    exhibitions: Exhibition[] = [];
    sidepots: Sidepot[] = [];
    editing: boolean;
    roughStock: boolean;

    configuration: EventTypeConfiguration;

    mixedTeams: boolean;

    payoutConfigs: RodeoEventPayoutConfig[] = [];

    singleDate: boolean;

    priceTiers: PriceTier[];

    isRoughStock() {
        if (this.eventType === 'BullRiding' || this.eventType === 'SaddleBroncRiding' || this.eventType === 'RanchBroncRiding' || this.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    constructor() {
        this.id = 0;
        this.roundStyleId = 1;
        this.roundStyle = { id: 1, name: 'Progressive' };
        this.schedules = [];
        this.configuration = new EventTypeConfiguration();
        this.eventType = 'BullRiding';
        this.displayName = 'Bull Riding';
        this.ropingFormat = 'Pick';
        this.reverseSecondRound = false;
        this.reverseSecondRoundDragOnly = false;
        this.maxEntries = 32000;
        this.barrierPenalty = 10;
        this.progressiveAfter = 1;
        this.eventOrders = [];
        this.registrations = [];
        this.winners = [];
        this.exhibitions = [];
        this.ageFloor = 0;
        this.ageCap = 100;
        this.ageMethod = "Day Of";
        this.shortGo = false;
        this.shortGoMax = 1;
        this.fallBackToFill = false;
        this.fallBackToPlace = false;
        this.rotationMax = 0;
        this.barrelPenalty = 5;
        this.lateFee = 0;
        this.stockFee = 0;
        this.lateFeeType = 'PERRIDER';
        this.allowDrawAll = false;
        this.allowTBA = false;
        this.showBaseTime = 25;
        this.baseJudgeScore = 0;
        this.crossfireTimePenalty = 0;
        this.mixedTeams = false;
    }
}


// WEBPACK FOOTER //
// ./src/model/rodeoEvent.ts